// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2aybi","log":"ModalInventoryLogs_log__3X6B-","date":"ModalInventoryLogs_date__Mfk_-","userName":"ModalInventoryLogs_userName__jmxEC"};